import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { ChecklistTemplate } from '../../types/logistica';
import { checklistTemplatesService } from '../../services';

const columns: ResourceColumn<ChecklistTemplate>[] = [
  { header: "Nome", accessor: "nome" },
  { header: "Ativo", accessor: "ativo" },
];

export const ChecklistTemplatesListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Templates de Checklist"
      description="Gerenciamento de templates de checklists para inspeção de veículos."
      columns={columns}
      service={checklistTemplatesService}
      createPath="/admin/logistica/checklist-templates/novo"
      onEdit={(item) => item.id && navigate(`/admin/logistica/checklist-templates/${item.id}`)}
    />
  );
};
